var ArrayHelper = /** @class */ (function () {
    function ArrayHelper() {
    }
    /* DEPRECATED We should use the one on core components*/
    ArrayHelper.prototype.diff = function (from, comparedWith) {
        return from.filter(function (i) {
            return comparedWith.indexOf(i) < 0;
        });
    };
    ;
    ArrayHelper.prototype.updateObject = function (old, newValue, addNewKeys) {
        if (old === void 0) { old = {}; }
        if (newValue === void 0) { newValue = {}; }
        if (addNewKeys === void 0) { addNewKeys = false; }
        var value = newValue || {};
        for (var i in old) {
            if (value.hasOwnProperty(i)) {
                old[i] = value[i];
            }
        }
        if (addNewKeys) {
            var newKeys = this.diff(Object.keys(value), Object.keys(old));
            for (var i in newKeys) {
                if (value.hasOwnProperty(newKeys[i])) {
                    old[newKeys[i]] = value[newKeys[i]];
                }
            }
        }
        return old;
    };
    ArrayHelper.prototype.clean = function (array) {
        if (array && typeof array === 'object') {
            var keys = Object.keys(array);
            for (var i in keys) {
                var k = keys[i];
                if (array[k] == null || typeof array[k] === 'undefined') {
                    delete array[k];
                }
            }
        }
        return array;
    };
    ArrayHelper.prototype.cloneDeep = function (mainArray) {
        return JSON.parse(JSON.stringify(mainArray));
    };
    ArrayHelper.prototype.orderBy = function (array, orderField, orderDesc) {
        if (orderDesc === void 0) { orderDesc = false; }
        array.sort(function (itemA, itemB) {
            var valueA = itemA[orderField];
            var valueB = itemB[orderField];
            return orderDesc
                ? valueA > valueB ? -1 : 1
                : valueB > valueA ? -1 : 1;
        });
        return array;
    };
    return ArrayHelper;
}());
export { ArrayHelper };
